import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-white text-gray-700 py-12 px-4 sm:px-6 lg:px-8 border-t border-gray-200">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-center items-center gap-8">
          <p className="text-sm">&copy; 2026 上海音乐学院. 保留所有权利</p>
          <div className="flex justify-center items-center gap-8">
            <img src="/shangyin-logo.png" alt="上海音乐学院" className="h-16 object-contain" />
            <img src="/lab-logo.png" alt="实验室" className="h-16 object-contain" />
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
